export type InvoiceChargeTotalInput = {
  quantity: number
  rateInCents: number
}

export function calculateInvoiceChargeTotalInMainCurrency(charge: InvoiceChargeTotalInput) {
  const totalInCents = charge.quantity * charge.rateInCents

  return Math.round(totalInCents) / 100
}

export function calculateInvoiceCategoryTotalInMainCurrency(charges: InvoiceChargeTotalInput[]) {
  return charges.reduce(
    (total, charge) => total + calculateInvoiceChargeTotalInMainCurrency(charge),
    0
  )
}
